<template>
  <div class="main" v-if="!showTechnical">
    <div class="main_header">
      <div class="header_item">
      <!-- <el-button 
        :size="size" 
        icon="el-icon-search"
        v-if="showButton('search')"
        @click="searchTechnicalTypeList(true)"
        >查询</el-button> -->
      <el-button 
        class="search_btn"
        icon="el-icon-plus"
        v-if="showButton('insert')"
        @click="propInsert()">新增</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="technicalTypeList"
        height="100%" >
        <el-table-column label="序号" align="center">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="tchFileTypeName" label="文件类型" align="center"></el-table-column>
        <el-table-column label="操作" align="center">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="propUpdate(row)">修改</el-button>
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
            <el-button class="table_btn" size="mini" v-if="showButton('delete')" @click="propTechnical(row)">文件列表</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <!-- 新增技术文件类型 修改技术文件类型信息 -->
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle ? '新增技术文件类型' : '修改技术文件类型信息'"
      :visible.sync="asyncTechnicalType"
      width="35%">
      <el-form ref="form" :model="formTechnicalType" label-width="auto" class="rule_form">
        <el-form-item label="文件类型名称：" :rules="{
          required: true, 
          message: '请输入文件类型名称', 
          trigger: 'blur'
        }">
          <el-input v-model="formTechnicalType.tchFileTypeName" :size="size" clearable placeholder="请输入文件类型名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button :size="size" @click="asyncTechnicalType = false">取 消</el-button>
        <el-button :size="size" @click="asyncTitle ? submitInsertForm() : submitUpdateForm()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
  <div v-else>
    <technical-list :show-technical.sync="showTechnical" :type-id="tchFileTypeId"></technical-list>
  </div>
</template>

<script>
import { buttonPinia } from '../../pinia';
import { changeSize, throttle } from '../../plugins/public';
import TechnicalList from './components/TechnicalList';
  export default {
    data() {
      return {
        size: changeSize(),
        total: 0,
        pageNum: 1,
        pageSize: 10,
        loading: false,
        technicalTypeList: [], // 技术文件类型列表
        asyncTitle: true, // true 新增技术文件类型 false 修改技术文件类型信息
        asyncTechnicalType: false, // 弹窗
        formTechnicalType: {}, // 表单信息
        showTechnical: false,
        tchFileTypeId: '',
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchTechnicalTypeList(true);
    },
    methods: {
      // 查询技术文件类型列表信息
      searchTechnicalTypeList(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        this.loading = true;
        this.technicalTypeList = [];
        this.$api.Project.searchTechnicalTypeList({
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }).then((res) => {
          if(res.success) {
            this.total = res.data.total;
            this.technicalTypeList = res.data.list;
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        })
      },
      // 打开添加信息
      propInsert() {
        this.asyncTitle = true;
        this.asyncTechnicalType = true;
      },
      // 打开修改信息
      propUpdate() {
        this.asyncTitle = false;
        this.asyncTechnicalType = true;
      },
      // 打开文件列表
      propTechnical(row) {
        this.showTechnical = true;
        this.tchFileTypeId = row.tchFileTypeId;
      },
      // 删除信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该技术文件类型信息，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.Project.deleteTechnicalTypeInfo({tchFileTypeId: row.tchFileTypeId})
        .then(res => {
          if(res.statusMsg === 'ok') {
            this.searchTechnicalTypeList(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 提交添加信息
      submitInsertForm: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formTechnicalType);
            this.$api.Project.insertTechnicalTypeInfo(params).then((res) => {
              if(res.success) {
                this.asyncTechnicalType = false;
                this.searchTechnicalTypeList(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改信息
      submitUpdateForm: throttle(function() {
        this.$refs.form.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.formTechnicalType);
            this.$api.Project.insertTechnicalTypeInfo(params).then((res) => {
              if(res.success) {
                this.asyncTechnicalType = false;
                this.searchTechnicalTypeList(true);
                this.$$message.success('修改成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 切换页码
      changePageNum(page) {
        this.pageNum = page;
        this.searchTechnicalTypeList();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchTechnicalTypeList();
      },
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      }
    },
    components: {
      TechnicalList
    },
    watch: {
      asyncTechnicalType(bol) {
        if(!bol) {
          this.formTechnicalType = {};
          this.$refs.form.resetFields();
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
@import '../../style/layout-main.scss';
</style>